export default __webpack_public_path__ + "static/media/weatherapp.1fe63d41.png";